export const normalizeEmail = (value) => value && value.toLowerCase();
